const collapseOnScroll = {
	ui: {},

	init: function() {
		this.ui.previousSrollTop = 0;
		this.ui.delayLaunch = true;

		setTimeout(()=>{
			this.ui.delayLaunch = false;
		},5000)

		this.bindUI();
		this.bindEvents();
	},

	bindUI: function bindUI() {

		this.ui.$window = $(window);

		this.ui.$header = $(".js-menu-nav");
	},

	bindEvents: function bindEvents() {
		this.ui.$window.on('scroll', this.collapseOnScroll.bind(this));
	},

	collapseOnScroll: function(e){
		if(!this.ui.lock && !this.ui.delayLaunch){
			window.requestAnimationFrame(() => {
				if(this.ui.previousSrollTop > 0 && this.ui.previousSrollTop < window.scrollY && window.scrollY > 120){
					this.ui.$header.addClass("collapse");
				}else{
					this.ui.$header.removeClass("collapse");
				}
				this.ui.previousSrollTop = window.scrollY;
			});
		}
	}
};

module.exports = collapseOnScroll;
